var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-facing-decorator';
import { Notifier } from "@/common/utils/notifier";
import { Feature, CompaniesClient, GetIssueListPaginatedQuery, IssuesClient, LookupsClient, PaginatedEnumerableOfIssueModel, SitesClient, SortDescription, SortDirection, SystemsClient, IssueAction, SystemCategoriesClient, GetSystemCategoryListQuery } from "@/app/api/battery-portal-api";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { CacheHelper } from "@/app/utils/cache-helper";
import QueryStringHelper from "@/app/utils/querystring-helper";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
import { DatePresetOption } from "@/common/enums/date-preset";
import RouteNames from "@/app/router/routes";
import Sorter from "@/common/utils/sorter";
const systemsClient = new SystemsClient(window.apiUrl);
const issuesClient = new IssuesClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const lookupClient = new LookupsClient(window.apiUrl);
const systemCategoriesClient = new SystemCategoriesClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let IssuesVue = class IssuesVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.snoozeSearch = false;
        this.systemsLoaded = false;
        this.lookupsLoaded = false;
        this.searchAttempted = false;
        this.datePickerConfig = {
            dateFormat: "d M Y",
            wrap: true,
            enableTime: false,
            allowInput: false
        };
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "WhenCreated",
            direction: SortDirection.Descending
        }));
        // models
        this.query = new GetIssueListPaginatedQuery({
            page: 1,
            pageSize: 100,
            keywords: "",
            includeDeleted: false,
            companyId: null,
            siteId: null,
            systemId: null,
            assignedId: null,
            createdById: null,
            action: null,
            severity: null,
            categoryId: null,
            startTime: null,
            endTime: null,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfIssueModel();
        this.systems = [];
        this.companies = [];
        this.sites = [];
        this.users = [];
        this.systemCategories = [];
        this.actionTypes = [
            { value: null, text: 'Any action' },
            { value: IssueAction.Watch, text: 'Watch' },
            { value: IssueAction.Task, text: 'Task' },
            { value: IssueAction.Resolved, text: 'Resolved' }
        ];
        this.severityTypes = [
            { value: null, text: 'Any severity' },
            { value: 1, text: 'Critical' },
            { value: 2, text: 'Warning' },
            { value: 3, text: 'Info' }
        ];
        this.dateFilterOptions = ["W", "M", "3M", "Y", "All", "..."];
        this.dateFilterOption = "";
        // Add to the class properties
        this.columns = [
            { visible: true, fieldName: "issueId", title: "#" },
            { visible: true, fieldName: "created", title: "Created" },
            { visible: true, fieldName: "system", title: "System" },
            { visible: true, fieldName: "description", title: "Description" },
            { visible: true, fieldName: "location", title: "Location" },
            { visible: true, fieldName: "action", title: "Action" },
            { visible: true, fieldName: "assigned", title: "Assigned" },
            { visible: true, fieldName: "updated", title: "Updated" }
        ];
    }
    get categoryTypes() {
        return this.systemCategories;
    }
    created() {
        this.loadDataGridState();
        this.resetDateFilterOption();
    }
    mounted() {
        this.getLookups();
        this.getSystems();
        this.loadCategories();
    }
    // get
    getSystems() {
        systemsClient
            .getSystems(false, Feature.Issue_View)
            .then(response => {
            if (!response)
                return;
            this.systems = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.systemsLoaded = true;
        });
    }
    getLookups() {
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `Any company` }].concat(companies);
            }),
            siteClient
                .getListForUser()
                .then(response => {
                if (!response)
                    return;
                this.sites = response;
            }),
            this.loadUsers()
        ];
        Promise.all(promises).then(() => {
            try {
                if (this.cachedItemExists()) {
                    this.initializeCachedFilters();
                }
            }
            catch (e) {
                console.error(e);
                this.removeCachedFilters();
            }
            this.lookupsLoaded = true;
        });
    }
    loadUsers() {
        var _a;
        return lookupClient.getUsersForMyCompanies((_a = this.company) === null || _a === void 0 ? void 0 : _a.value)
            .then(response => {
            this.users = (response || []).map(item => ({
                value: item.userId,
                text: item.displayName
            }));
        });
    }
    loadCategories() {
        var _a;
        let queryCategory = new GetSystemCategoryListQuery({
            companyId: (_a = this.company) === null || _a === void 0 ? void 0 : _a.value,
            includeDeleted: false
        });
        systemCategoriesClient
            .getListPOST(queryCategory)
            .then(response => {
            var _a;
            this.systemCategories = [{ value: null, text: "Any category" }].concat((response || []).map((item) => {
                return {
                    value: item.id,
                    text: item.name || ""
                };
            }));
            if (!this.category)
                this.category = this.systemCategories[0];
            else {
                this.category = (_a = this.systemCategories.find(item => item.value == this.category.value)) !== null && _a !== void 0 ? _a : this.systemCategories[0];
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    get creators() {
        let creators = (this.users || []).filter(user => user.value != null);
        return [{ value: null, text: 'Any Creator' }].concat(creators);
    }
    get assignees() {
        let assignees = (this.users || []).filter(user => user.value != null);
        return [{ value: null, text: 'Any Assignee' }].concat(assignees);
    }
    onCompanyIdChanged() {
        try {
            this.siteId = this.filteredSites[0];
            this.loadCategories();
            this.loadUsers()
                .then(() => {
                this.assignedId = this.users[0];
                this.createdById = this.users[0];
                this.search();
            });
        }
        catch (ex) {
            console.error(ex);
        }
    }
    onSiteIdChanged() {
        this.search();
    }
    search() {
        if (this.working)
            return;
        if (!this.readyToBindQueryStringFilters)
            return;
        if (this.snoozeSearch)
            return;
        if (this.startDateInvalid || this.endDateInvalid)
            return;
        this.working = true;
        let query = this.query;
        let startTime = query.startTime ? DateHelper.convertToDate(query.startTime.toString()) : null;
        let endTime = query.endTime ? DateHelper.convertToDate(query.endTime.toString()) : null;
        if (endTime != null)
            endTime = DateHelper.getEndOfDay(endTime);
        if (!DateHelper.validateDateRange(startTime, endTime)) {
            this.working = false;
            Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
            return;
        }
        query.startTime = startTime;
        query.endTime = endTime;
        issuesClient
            .search(query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.page = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
            let params = [
                { value: this.query.companyId, parameterName: "companyId" },
                { value: this.query.siteId, parameterName: "siteId" },
                { value: this.dateFilterOption, parameterName: "period" },
            ];
            if (this.dateFilterOption == "...") {
                params.push({
                    value: startTime === null || startTime === void 0 ? void 0 : startTime.toISOString(),
                    parameterName: "startTime"
                });
                params.push({
                    value: endTime === null || endTime === void 0 ? void 0 : endTime.toISOString(),
                    parameterName: "endTime"
                });
            }
            queryStringHelper.updateQueryStrings(params);
        })
            .catch((ex) => {
            console.error('error on search', ex);
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
            this.storeFiltersToCache();
        });
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.search();
        }
    }
    onReadytoQuery() {
        this.search();
    }
    onSeverityChanged() {
        this.search();
    }
    onCategoryChanged() {
        this.search();
    }
    onDataGridStateChanged() {
        DataGridStateHelper.storeDataGridState("issues-grid", this.columns, this.sorter, this.query.includeDeleted);
    }
    onIncludeDeletedChanged() {
        this.search();
    }
    edit(item) {
        this.$router.push({
            name: 'issue',
            params: { id: item.issueId.toString() }
        });
    }
    archive(item) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this issue?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            issuesClient
                .delete(item.issueId)
                .then(() => {
                item.whenDeleted = new Date();
                Notifier.onOk(`Issue #${item.issueId} has been archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    restore(item) {
        if (this.working)
            return;
        this.working = true;
        issuesClient
            .restore(item.issueId)
            .then(() => {
            item.whenDeleted = undefined;
            Notifier.onOk(`Issue #${item.issueId} has been restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    // Date filter methods
    resetDateFilterOption() {
        this.dateFilterOption = "W";
        this.setDateRange();
    }
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (this.dateFilterOption == "...")
            return;
        this.setDateRange();
        this.search();
    }
    setDateRange() {
        this.snoozeSearch = true;
        let range = DateHelper.getDateRange(DatePresetOption.OneMonth);
        switch (this.dateFilterOption) {
            case "W":
                range = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "M":
                range = DateHelper.getDateRange(DatePresetOption.OneMonth);
                break;
            case "3M":
                range = DateHelper.getDateRange(DatePresetOption.ThreeMonths);
                break;
            case "Y":
                range = DateHelper.getDateRange(DatePresetOption.OneYear);
                break;
            case "All":
                range = { start: null, end: null };
                break;
        }
        if (!range)
            return;
        this.query.startTime = range.start;
        this.query.endTime = range.end;
        this.snoozeSearch = false;
    }
    // Computed properties
    get filteredSites() {
        let sites = (this.sites || [])
            .filter(site => { var _a; return ((_a = this.company) === null || _a === void 0 ? void 0 : _a.value) == null || site.companyId == this.company.value; })
            .map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        return [{ value: null, text: `Any site` }].concat(sites);
    }
    get filteredSystems() {
        let systems = this.systems
            .filter(system => { var _a, _b; return (((_a = this.companyId) === null || _a === void 0 ? void 0 : _a.value) == null || this.companyId.value == system.companyId) && (((_b = this.siteId) === null || _b === void 0 ? void 0 : _b.value) == null || this.siteId.value == system.siteId); })
            .map((system) => {
            return {
                value: system.systemId,
                text: system.systemName
            };
        });
        return [{ value: null, text: `Any system` }].concat(systems);
    }
    get systemId() {
        return this.query.systemId;
    }
    ;
    get system() {
        return this.filteredSystems.filter(item => {
            return item.value == this.systemId;
        })[0] || null;
    }
    ;
    set system(item) {
        if (item) {
            this.query.systemId = item.value;
        }
    }
    ;
    get company() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set company(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get site() {
        return this.filteredSites.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set site(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get action() {
        return this.actionTypes.filter(item => {
            return item.value == this.query.action;
        })[0] || null;
    }
    ;
    set action(item) {
        if (!item)
            return;
        this.query.action = item.value;
    }
    get assigned() {
        return this.users.filter(item => {
            return item.value == this.query.assignedId;
        })[0] || null;
    }
    ;
    set assigned(item) {
        if (!item)
            return;
        this.query.assignedId = item.value;
    }
    ;
    get createdBy() {
        return this.users.filter(item => {
            return item.value == this.query.createdById;
        })[0] || null;
    }
    ;
    set createdBy(item) {
        if (!item)
            return;
        this.query.createdById = item.value;
    }
    ;
    get severity() {
        return this.severityTypes.filter(item => {
            return item.value == this.query.severity;
        })[0] || null;
    }
    set severity(item) {
        if (!item)
            return;
        this.query.severity = item.value;
    }
    get category() {
        return this.categoryTypes.filter(item => {
            return item.value == this.query.categoryId;
        })[0] || null;
    }
    set category(item) {
        if (!item)
            return;
        this.query.categoryId = item.value;
    }
    get readyToBindQueryStringFilters() {
        return this.systemsLoaded && this.lookupsLoaded;
    }
    get noData() {
        return this.searchAttempted &&
            (!this.data || !this.data.records || !this.data.records.length);
    }
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    get areDatesInvalid() {
        if (this.query.startTime == null ||
            this.query.endTime == null ||
            this.startDateInvalid ||
            this.endDateInvalid)
            return false;
        let startTime = DateHelper.convertToDate(this.query.startTime.toString());
        let endTime = DateHelper.convertToDate(this.query.endTime.toString());
        return (startTime >= endTime);
    }
    get startDateInvalid() {
        if (!this.query.startTime)
            return false;
        try {
            return isNaN(Date.parse(this.query.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    get endDateInvalid() {
        if (!this.query.endTime)
            return false;
        try {
            return isNaN(Date.parse(this.query.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    // Helper methods
    getFormattedDate(date) {
        return DateHelper.convertToFriendlyMomentTimeString(date);
    }
    getPeriodTitle(item) {
        return DateHelper.getDateFilterOptionTitle(item);
    }
    getSeverityClass(item) {
        switch (item.severity) {
            case 1: // IssueSeverity.Critical
                return 'critical';
            case 2: // IssueSeverity.Warning
                return 'warning';
            case 3: // IssueSeverity.Info
                return 'info';
            case 4: // IssueSeverity.Ok
                return 'ok';
            default: // IssueSeverity.Info
                return '';
        }
    }
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    // Add method to load saved state
    loadDataGridState() {
        this.working = true;
        try {
            var state = DataGridStateHelper.loadDataGridState("issues-grid", this.columns, this.sorter);
            if (state != null) {
                this.query.includeDeleted = state.includeDeleted;
            }
        }
        finally {
            this.working = false;
        }
    }
    // Cache methods
    cachedItemExists() {
        return CacheHelper.getItem(RouteNames.Issues, "IssuesFilterQuery") != null;
    }
    ;
    initializeCachedFilters() {
        var _a;
        let cachedFilterModel = CacheHelper.getItem(RouteNames.Issues, "IssuesFilterQuery");
        this.query = (_a = cachedFilterModel === null || cachedFilterModel === void 0 ? void 0 : cachedFilterModel.query) !== null && _a !== void 0 ? _a : this.query;
        if (cachedFilterModel === null || cachedFilterModel === void 0 ? void 0 : cachedFilterModel.dateFilterOption) {
            var cachedDateFilterOption = cachedFilterModel.dateFilterOption;
            this.setDateFilterOption(cachedDateFilterOption);
        }
    }
    ;
    storeFiltersToCache() {
        let cachedFilterModel = {
            query: this.query,
            dateFilterOption: this.dateFilterOption
        };
        CacheHelper.storeItem(RouteNames.Issues, "IssuesFilterQuery", cachedFilterModel);
    }
    ;
    removeCachedFilters() {
        CacheHelper.removeItem(RouteNames.Issues, "IssuesFilterQuery");
    }
    ;
};
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("query.siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "onSiteIdChanged", null);
__decorate([
    Watch("query.startTime"),
    Watch("query.endTime"),
    Watch("query.assignedId"),
    Watch("query.createdById"),
    Watch("query.action"),
    Watch("query.page"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "onSortChanged", null);
__decorate([
    Watch("readyToBindQueryStringFilters"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "onReadytoQuery", null);
__decorate([
    Watch("query.severity"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "onSeverityChanged", null);
__decorate([
    Watch("query.categoryId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "onCategoryChanged", null);
__decorate([
    Watch('numberOfVisibleColumns'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch('query.includeDeleted'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IssuesVue.prototype, "onIncludeDeletedChanged", null);
IssuesVue = __decorate([
    Component({
        name: "IssuesVue"
    })
], IssuesVue);
export default IssuesVue;
